import { render, staticRenderFns } from "./readerRules.vue?vue&type=template&id=1c553b60&scoped=true"
import script from "./readerRules.vue?vue&type=script&lang=js"
export * from "./readerRules.vue?vue&type=script&lang=js"
import style0 from "./readerRules.vue?vue&type=style&index=0&id=1c553b60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c553b60",
  null
  
)

export default component.exports